import React from 'react';
export var Mention = function (_a) {
    var children = _a.children, mentionedUser = _a.node.mentionedUser;
    return (React.createElement("span", { className: 'str-chat__message-mention', "data-user-id": mentionedUser.id }, children));
};
